import type { ExerciseSetStatistic } from '../types';
import { AutomaticMetricsType } from '../constants';

export const calculateConcentricCompliance = (
  statistic: ExerciseSetStatistic,
): string | null => {
  const { analyzedMetrics, metrics, performedReps } = statistic;
  if (!analyzedMetrics || !metrics) return null;
  const { concentric } = metrics;
  const { min, max, type } = concentric;
  const isTempoMetric = type === AutomaticMetricsType.Tempo;
  const goodConcentricReps = Object.values(analyzedMetrics).filter((metric) =>
    isTempoMetric
      ? metric.upDuration >= min && metric.upDuration <= max
      : metric.upVelocity >= min && metric.upVelocity <= max,
  );
  const rawPercentage = (goodConcentricReps.length / performedReps) * 100;
  return `${rawPercentage.toFixed(1)}%`;
};

export const calculateEccentricCompliance = (
  statistic: ExerciseSetStatistic,
): string | null => {
  const { analyzedMetrics, metrics, performedReps } = statistic;
  if (!analyzedMetrics || !metrics) return null;
  const { eccentric } = metrics;
  const { min, max, type } = eccentric;
  const isTempoMetric = type === AutomaticMetricsType.Tempo;
  const goodEccentricReps = Object.values(analyzedMetrics).filter((metric) =>
    isTempoMetric
      ? metric.downDuration >= min && metric.downDuration <= max
      : metric.downVelocity >= min && metric.downVelocity <= max,
  );
  const rawPercentage = (goodEccentricReps.length / performedReps) * 100;
  return `${rawPercentage.toFixed(1)}%`;
};

export const calculateRepsCompliance = (
  performedReps: number,
  targetReps?: number,
): string => {
  if (targetReps === undefined || targetReps === 0) return '-';
  const compliance = (performedReps / targetReps) * 100;
  return `${compliance.toFixed(1)}%`;
};
